export const LOGO = require('./logo.png');
export const APPNAME = require('./appname.png');
export const HEADER_IMAGE = require('./headerimage.png');
